// extracted by css-extract-rspack-plugin
export default {"Box_0":"VisibleItem-module__Box_0__t4MtG"};